import { FIELD_BASE_CLASS, fieldBorderClass } from '@/components/base/shared-classes';

export interface PasswordInputProps {
  uiId: string;
  value: string;
  onChange: (next: string) => void;
  placeholder?: string;
  disabled?: boolean;
  readOnly?: boolean;
  invalid?: boolean;
  name?: string;
  /** 原生 required 屬性（批次 25 #27：index 登入頁 loginPin required；FC-3 欄位比對含 required attr）。 */
  required?: boolean;
  /** 原系統 loginPin maxlength=100（index.jsp:104）。 */
  maxLength?: number;
  /** 原系統 loginPin autocomplete="off"（index.jsp:104）；預設 current-password 維持既有行為。 */
  autoComplete?: string;
}

/** 與 TextInput 相同來源：bootstrap.css:2589-2593。 */
const DISABLED_BG_CLASS = 'disabled:bg-[#eee]';

/**
 * 密碼輸入。除了 `type="password"` 與 autoComplete 之外，外觀與行為和 TextInput 相同。
 *
 * ponytail: 沒有做成 `<TextInput type="password">`，因為那要在 TextInput 的公開契約上多開一個
 * type prop，讓「文字欄位」變成什麼都能塞的萬用元件（§9.5 明文禁止）。多這十幾行比較誠實。
 * 也沒有做「顯示／隱藏密碼」的眼睛按鈕：原系統登入頁沒有這個功能，不先做（§9.5）。
 */
export function PasswordInput({
  uiId,
  value,
  onChange,
  placeholder,
  disabled = false,
  readOnly = false,
  invalid = false,
  name,
  required = false,
  maxLength,
  autoComplete = 'current-password',
}: PasswordInputProps) {
  return (
    <input
      type="password"
      data-ui-id={uiId}
      name={name}
      required={required || undefined}
      maxLength={maxLength}
      className={`${FIELD_BASE_CLASS} ${fieldBorderClass(invalid)} ${DISABLED_BG_CLASS}`}
      value={value}
      placeholder={placeholder}
      disabled={disabled}
      readOnly={readOnly}
      aria-invalid={invalid}
      autoComplete={autoComplete}
      onChange={(event) => onChange(event.target.value)}
    />
  );
}
